import { render } from "./BaseChartLegendItem.vue?vue&type=template&id=faca63c2&ts=true"
import script from "./BaseChartLegendItem.vue?vue&type=script&lang=ts"
export * from "./BaseChartLegendItem.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__